import { render, staticRenderFns } from "./app_version.vue?vue&type=template&id=095d6a8a&scoped=true&"
import script from "./app_version.vue?vue&type=script&lang=js&"
export * from "./app_version.vue?vue&type=script&lang=js&"
import style0 from "./app_version.vue?vue&type=style&index=0&id=095d6a8a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "095d6a8a",
  null
  
)

export default component.exports